import UploadModal from './UploadModal';

export default UploadModal;


// WEBPACK FOOTER //
// ./src/components/Upload/index.js